import axios from 'axios';
import { ElMessage } from 'element-plus';
// 防止循环引用，我们需要使用import()动态导入
// import authState from './authState';
import eventBus, { EventTypes } from './eventBus';


// 创建axios实例
const request = axios.create({
  baseURL: import.meta.env.VITE_JAVA_API_URL, // 基础URL，将与API请求的路径组合
  timeout: 30000, // 超时时间，单位毫秒
});

// 判断是否正在刷新令牌的标志
let isRefreshing = false;
// 存储等待刷新令牌的请求队列
let requestsQueue = [];
// 跟踪登录过期提示是否已显示
let loginExpiredAlertShown = false;
// 提示冷却时间(毫秒)
const ALERT_COOLDOWN = 3000;

// 执行队列中的请求
const processQueue = (error = null) => {
  requestsQueue.forEach(({ resolve, reject, config }) => {
    if (error) {
      reject(error);
    } else {
      // 获取最新的令牌
      const token = localStorage.getItem('token');
      if(token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      resolve(request(config)); // 重新发送请求
    }
  });
  // 清空队列
  requestsQueue = [];
};

// 获取authState的函数，避免循环引用
const getAuthState = async () => {
  // 防止循环引用，动态导入
  const authStateModule = await import('./authState');
  return authStateModule.default;
};

// 请求拦截器
request.interceptors.request.use(
  async config => {
    // 如果是刷新令牌的请求，直接使用刷新令牌
    if (config.url && config.url.includes('/v1/auth/refresh')) {
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        config.headers['Authorization'] = `Bearer ${refreshToken}`;
      }
      return config;
    }
    
    // 对于其他请求，检查访问令牌是否有效
    const token = localStorage.getItem('token');
    if (token) {
      // 验证令牌状态并在需要时刷新
      try {
        const authState = await getAuthState();
        if (authState.token && authState.token.value) {
          const isValid = await authState.validateToken();
          if (!isValid) {
            console.warn('令牌无效，请求可能会失败');
          }
        }
      } catch (error) {
        console.error('验证令牌时出错:', error);
      }
      
      // 无论刷新是否成功，都使用当前最新的令牌（可能是新刷新的，也可能是原来的）
      const currentToken = localStorage.getItem('token');
      if (currentToken) {
        config.headers['Authorization'] = `Bearer ${currentToken}`;
      }
    }
    
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  async response => {
    // 如果响应成功
    if (response.data && response.data.code === 200) {
      return response;
    }else{
      const authState = await getAuthState();
      //判断是否是401
      if(response.data.code === 401){
        // 防抖动处理，确保短时间内只显示一次提示
        if (!loginExpiredAlertShown) {
          loginExpiredAlertShown = true;
          
          //跳转登录页
          eventBus.emit(EventTypes.AUTH_TOKEN_EXPIRED, {
            code: 'TOKEN_EXPIRED',
            message: '您的登录已过期，请重新登录'
          });
          authState.logout(); // 执行登出操作
          
          // 设置定时器，在冷却时间后重置标志
          setTimeout(() => {
            loginExpiredAlertShown = false;
          }, ALERT_COOLDOWN);
        }
      }
    }
    return response;
  },
  async error => {
    debugger;
    // 如果响应失败，处理错误
    console.error('响应错误:', error);
    ElMessage.error('请求失败');
    // 处理错误消息
    let errorMessage = '请求失败';  
    // 显示错误消息
    ElMessage.error(errorMessage);
    return Promise.reject(error);
  }
);

export default request;